<template>
  <div>
    <Form :label-width="80" inline>
      <FormItem label="地区" required>
        <Select style="width: 110px;" v-model="argumentForm.district" @on-change="getChildCompanies">
          <Option v-for="district in districts" :value="district.name" :key="district.name">{{district.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="分子公司" required>
        <Select style="width: 240px;" v-model="argumentForm.filiale">
          <Option v-for="company in childCompanies" :value="company.cName" :key="company.id">{{company.cName}}</Option>
        </Select>
      </FormItem>
      <FormItem label="类型" required>
        <Select style="width: 150px;" v-model="argumentForm.argumentType">
          <Option v-for="arguType in argumentTypes" :value="arguType.title" :key="arguType.title">{{arguType.title}}</Option>
        </Select>
      </FormItem>
        <FormItem label="编号" required>
          <Input style="width:120px;" v-model="argumentForm.argumentFull" readonly></Input>
        </FormItem>
        <Button size="small" type="primary" style="margin-top:5px;" @click="buildNum" :disabled="newNumDisabled">生成编号</Button>
      <div>
        <FormItem label="名称" required>
          <Input style="width:300px;" v-model="argumentForm.argumentName"></Input>
        </FormItem>
      </div>
      <div>
        <FormItem label="关联项目">
          <Input style="width:300px;" type="textarea" :autosize="true" readonly v-model="projectFulls" :title="projectFulls"></Input>
          <div style="color:#ed4014;width:300px;line-height:20px;">除项目前类型，必须关联项目（可多项目），以第一个关联项目作为专家费申请项目</div>
        </FormItem>
        <Button type="primary" size="small" @click="projectChooseVisible=true" style="margin-top:5px;">新增关联</Button>
        <Button type="primary" size="small" @click="clearProjectLink" style="margin-top:5px;margin-left:5px;">清空</Button>
      </div>
      <div>
        <FormItem label="备注">
          <Input style="width:300px;" v-model="argumentForm.comment"></Input>
        </FormItem>
      </div>
    </Form>
    <!-- 项目关联选择 -->
    <Modal v-model="projectChooseVisible" title="关联选择" :transfer="false" width="800">
      <project-choose @endImport="importProject"></project-choose>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import ProjectChoose from '@/components/projectChoose'
import { setTimeout } from 'timers';

export default {
  name: 'argumentForm',
  components: {
    ProjectChoose
  },
  props: {
    editArgument: {
      default: ''
    }
  },
  data() {
    return {
      districts: [],
      childCompanies: [],
      argumentForm: {
        id: '',
        district: '',
        argumentName: '',
        argumentFull: '',
        argumentType: '',
        comment: '',
        connectFullNum: [],
        connectProjectId: [],
        filiale: ''
      },
      argumentTypes: [
        {
          title: '论证（立项前）',
          linkRequired: false,
        },
        {
          title: '论证（立项后）',
          linkRequired: true,
        },
        {
          title: '质疑',
          linkRequired: true,
        },
        {
          title: '专家漏补',
          linkRequired: true,
        },
      ],
      projectChooseVisible: false
    }
  },
  created() {
    this.getDistrict()
  },
  computed: {
    projectFulls() {
      return this.argumentForm.connectFullNum.join(',')
    },
    newNumDisabled() {
      return this.argumentForm.argumentFull ? true : false
    }
  },
  methods: {
    async createOrUpdate() {
      const { argumentForm } = this
      if (argumentForm.argumentType === '' || argumentForm.district === '' || argumentForm.argumentName === '' || argumentForm.argumentFull === ''|| argumentForm.filiale === '') {
        this.$Message.info('请填写完整信息')
        return
      }
      if (argumentForm.argumentType.indexOf('立项前') === -1 && argumentForm.connectProjectId.length === 0) {
        this.$Message.info('请选择关联项目')
        return
      }
      
      try {
        this.$Spin.show()
        const deductProjectId = this.argumentForm.connectProjectId.length > 0 ? this.argumentForm.connectProjectId[0] : ''
        let rep = await ajax.post(requestUrls.AbpArgument.CreateOrUpdate, {
          abpArgument: {
            id: argumentForm.id,
            argumentName: argumentForm.argumentName,
            argumentFull: argumentForm.argumentFull,
            argumentType: argumentForm.argumentType,
            district: argumentForm.district,
            comment: argumentForm.comment,
            deductProjectId: deductProjectId,
            filiale: argumentForm.filiale
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$emit('createSuccess')
          this.$Message.success('操作成功')
          // 关联项目
          if (this.argumentForm.connectProjectId.length > 0) {
            let connectProjects = []
            this.argumentForm.connectProjectId.forEach(item => {
              connectProjects.push({
                argumentId: rep.data.result.id,
                projectId: item
              })
            })
            await ajax.post(requestUrls.AbpArgument.CreateArgumentExt, connectProjects)
          }
        } else {
          this.$Message.error('操作失败')
        }
      } catch(err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('操作失败')
      }
    },
    clearProjectLink() {
      this.argumentForm.connectProjectId = []
      this.argumentForm.connectFullNum = []
    },
    async getDistrict() {
      let rep = await ajax(requestUrls.CLDistrict.GetListWithoutRole)
      this.districts = []
      if (rep.data.success) {
        this.districts = rep.data.result.items
      }
    },
    async getChildCompanies(district) {
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: `district == "${district}"`
        }
      })
      this.childCompanies = []
      if (rep.data.success && rep.data.result.items.length > 0) {
        // 去除重复分子公司
        let hadPut = []
        rep.data.result.items.forEach(item => {
          if (hadPut.indexOf(item.cName) === -1) {
            hadPut.push(item.cName)
            this.childCompanies.push(item)
          }
        })
      }
    },
    async buildNum() {
      try {
        this.argumentForm.argumentFull = await this.newNum()
      } catch(err) {
        this.$Message.error('生成编号失败')
      }
    },
    async newNum() {
      let rep = await ajax.get(requestUrls.AbpArgument.GetArgumentNo)
      if (rep.data.success) {
        return rep.data.result
      }
      return ''
    },
    importProject(project) {
      this.argumentForm.connectProjectId.push(project.id)
      this.argumentForm.connectFullNum.push(project.projectFull)
      this.projectChooseVisible = false
    },
    async assignForm(formVal = {}) {
      this.argumentForm = {
        id: formVal.id,
        district: formVal.district,
        argumentName: formVal.argumentName,
        argumentFull: formVal.argumentFull,
        argumentType: formVal.argumentType,
        comment: formVal.comment,
        connectFullNum: [],
        connectProjectId: [],
        filiale: formVal.filiale
      }
      // setTimeout(() => {
      //   this.$set(this.argumentForm, 'district', formVal.district)
      //   this.$set(this.argumentForm, 'argumentType', formVal.argumentType)
      // }, 50)
      // 获取关联数据
      this.$Spin.show()
      let rep = await ajax.get(requestUrls.AbpArgument.GetByProject, {
        params: {
          argumentId: formVal.id
        }
      })
      this.$Spin.hide()
      if (rep.data.success && rep.data.result.length > 0) {
        rep.data.result.forEach(project => {
          this.argumentForm.connectFullNum.push(project.projectFull)
          this.argumentForm.connectProjectId.push(project.id)
        })
      }
    },
    clearFormData() {
      this.argumentForm = {
        id: '',
        district: '',
        argumentName: '',
        argumentFull: '',
        argumentType: '',
        comment: '',
        connectFullNum: [],
        connectProjectId: []
      }
    }
  },
  watch: {
    editArgument(val) {
      if (val !== '') {
        this.getChildCompanies(val.district)
        this.assignForm(val)
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
